export default {
    init($) {

        // JavaScript to be fired on the home page
    },
    finalize($) {
        setTimeout(() => {
            $('.publications .publications-list a').attr('target', '_blank');
        }, 500);
    },
};
